<template>
  <section>
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <!-- <el-form-item label="">
        <el-input style="width: 160px" v-model="filters.name" placeholder="医院名称"></el-input>
      </el-form-item> -->
      <el-form-item label="">
        <el-input style="width: 160px" v-model="filters.hospitalCode" placeholder="医院编码"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          style="width: 160px"
          v-model="filters.StartMonth"
          format="yyyy-MM"
          value-format="yyyy-MM"
          type="month"
          placeholder="开始月份"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          style="width: 160px"
          v-model="filters.EndMonth"
          format="yyyy-MM"
          value-format="yyyy-MM"
          type="month"
          placeholder="结束月份"
        ></el-date-picker>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="ExportAccou_Template">导出数据模版</el-button>
      </el-form-item>
      <el-form-item>
        <el-upload
          style="display: inline-block; margin-right: 20px; padding-bottom: 12px"
          class="upload-demo"
          ref="upload"
          action="/extapi/ims/uploadexcel"
          :data="{ checkOnly: Upload_IMS_isCheck }"
          :headers="token"
          :show-file-list="false"
          :on-success="handleSuccess"
          :before-upload="handlebefore"
          :on-error="handonerror"
        >
          <el-button type="primary">导入IMS销量数据</el-button>
          <!-- <el-button @click="btn_up_2(form1.filepath)" v-if="form1.filepath" type="primary">预览</el-button> -->
        </el-upload>
        <!-- <el-button type="primary" @click="Upload_IMS = true">导入IMS销量数据</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          border
          :max-height="tableHeight"
          :data="tabel_list"
          header-cell-class-name="header_cell_name"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column prop="time" label="销量月份" ></el-table-column>
          <el-table-column prop="zcnCode" label="医院编码" ></el-table-column>
          <el-table-column prop="name" label="医院名称" ></el-table-column>
          <el-table-column prop="positionNumber" label="销售岗位号" ></el-table-column>
          <el-table-column prop="productCode" label="产品编码"></el-table-column>
          <el-table-column prop="amount" label="销售金额" ></el-table-column>
          <el-table-column prop="refreshAmount" label="可比销售金额" ></el-table-column>
          <el-table-column prop="number" label="销售数量" >
            <template slot-scope="scope">
              {{ scope.row.number.toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="提交时间" ></el-table-column>
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="Upload_IMS" title="导入IMS销量数据" width="35%" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="是否校验">
          <el-switch style="margin-top: -3px" v-model="Upload_IMS_isCheck" active-text="是" inactive-text="否"></el-switch>
        </el-form-item>
        <el-form-item label="导入文件">
          <el-upload
            style="display: inline-block; margin-right: 20px; padding-bottom: 12px"
            class="upload-demo"
            ref="upload"
            action="/extapi/ims/uploadexcel"
            :data="{ checkOnly: Upload_IMS_isCheck }"
            :headers="token"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="handlebefore"
            :on-error="handonerror"
          >
            <el-button type="primary">上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog> -->
  </section>
</template>

<script>
import util from '../../../util/date'
import { ims_getsalesvolumelist, dashboard_getregionsbylevel, ims_exportsalesvolumetoexcel, ims_downloadtemplatefile } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import { uploadfiles } from '@/uploadfiles'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      Upload_IMS_isCheck: false,
      Upload_IMS: false,
      city_list: [],
      area_list: [],
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      pageIndex: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    handlebefore(file) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
    },
    handonerror() {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.code == 200) {
        loading.close()
        this.$message({
          message: file.data,
          type: 'success',
        })
        this.$refs.upload.clearFiles()
        this.getModules_search()
        // this.Upload_IMS = false
      } else {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'error',
        })
        this.$refs.upload.clearFiles()
      }
    },
    getRegionList(value) {
      const selectedOptions = this.area_list.filter((option) => option.regionName === value)
      this.city_list = selectedOptions[0].subRegions
      this.filters.city = ''
    },
    async dashboard_getregionsbylevel() {
      const { data } = await dashboard_getregionsbylevel()
      this.area_list = data.data.regions
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getModules()
    },
    getModules_search() {
      this.pageIndex = 1
      this.getModules()
    },
    async ExportAccou_Template() {
      let para = this.filters
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await ims_downloadtemplatefile(para)
      uploadfiles(data, headers, this.loading)
    },
    async ExportAccount() {
      let para = this.filters
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await ims_exportsalesvolumetoexcel(para)
      uploadfiles(data, headers, this.loading)
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.pageIndex = this.pageIndex
      this.listLoading = true
      ims_getsalesvolumelist(para).then((res) => {
        this.total = res.data.data.totalCount
        this.tabel_list = res.data.data.data
        console.log(this.tabel_list)
        this.listLoading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    this.isMobile = window.innerWidth <= 767
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 380
        } else {
          this.tableHeight = window.innerHeight - 230
        }
      })
    })
    this.getModules()
    // this.dashboard_getregionsbylevel()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped></style>
